export function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}



// WEBPACK FOOTER //
// ./src/utils/form-utils.js